module.exports = __webpack_public_path__ + "img/744.01956901.jpg";